/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CartModification,
  CartModificationList,
  ErrorList,
  OrderEntry,
  OrderEntryList,
} from '../models';
import {
    CartModificationFromJSON,
    CartModificationToJSON,
    CartModificationListFromJSON,
    CartModificationListToJSON,
    ErrorListFromJSON,
    ErrorListToJSON,
    OrderEntryFromJSON,
    OrderEntryToJSON,
    OrderEntryListFromJSON,
    OrderEntryListToJSON,
} from '../models';

export interface GetCartEntriesRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetCartEntryRequest {
    baseSiteId: string;
    cartId: string;
    entryNumber: number;
    userId: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface MediqCreateCartEntryRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    orderEntry: OrderEntry;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface RemoveCartEntryRequest {
    baseSiteId: string;
    cartId: string;
    entryNumber: number;
    userId: string;
    sapCommerceCloudCustomerId?: string;
}

export interface ReplaceCartEntriesRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    orderEntryList: OrderEntryList;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface ReplaceCartEntryRequest {
    baseSiteId: string;
    cartId: string;
    entryNumber: number;
    userId: string;
    orderEntry: OrderEntry;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface UpdateCartEntryRequest {
    baseSiteId: string;
    cartId: string;
    entryNumber: number;
    userId: string;
    orderEntry: OrderEntry;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

/**
 * CartEntriesApi - interface
 * 
 * @export
 * @interface CartEntriesApiInterface
 */
export interface CartEntriesApiInterface {
    /**
     * Retrieves a list of cart entries with the product data.
     * @summary Retrieves the cart entries.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartEntriesApiInterface
     */
    getCartEntriesRaw(requestParameters: GetCartEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderEntryList>>;

    /**
     * Retrieves a list of cart entries with the product data.
     * Retrieves the cart entries.
     */
    getCartEntries(requestParameters: GetCartEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderEntryList>;

    /**
     * Retrieves detailed information about a specific entry for the shopping cart.
     * @summary Retrieves the details of a cart entry.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {number} entryNumber Each entry in a cart has an entry number. Cart entries are numbered in ascending order, starting with zero.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartEntriesApiInterface
     */
    getCartEntryRaw(requestParameters: GetCartEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderEntry>>;

    /**
     * Retrieves detailed information about a specific entry for the shopping cart.
     * Retrieves the details of a cart entry.
     */
    getCartEntry(requestParameters: GetCartEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderEntry>;

    /**
     * Adds a product to the specified cart.
     * @summary Assigns a product to the cart.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {OrderEntry} orderEntry 
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartEntriesApiInterface
     */
    mediqCreateCartEntryRaw(requestParameters: MediqCreateCartEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CartModification>>;

    /**
     * Adds a product to the specified cart.
     * Assigns a product to the cart.
     */
    mediqCreateCartEntry(requestParameters: MediqCreateCartEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CartModification>;

    /**
     * Deletes a specified entry from the shopping cart to manage the product items.
     * @summary Deletes the cart entry.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {number} entryNumber Each entry in a cart has an entry number. Cart entries are numbered in ascending order, starting with zero.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartEntriesApiInterface
     */
    removeCartEntryRaw(requestParameters: RemoveCartEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deletes a specified entry from the shopping cart to manage the product items.
     * Deletes the cart entry.
     */
    removeCartEntry(requestParameters: RemoveCartEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Adds specific products or overwrites the details of existing products in the cart, based either on the product code or the entry number. For existing products, attributes not provided in the request body will be defined again (set to null or default).
     * @summary Updates the quantity of the specified products in a cart.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {OrderEntryList} orderEntryList 
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartEntriesApiInterface
     */
    replaceCartEntriesRaw(requestParameters: ReplaceCartEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CartModificationList>>;

    /**
     * Adds specific products or overwrites the details of existing products in the cart, based either on the product code or the entry number. For existing products, attributes not provided in the request body will be defined again (set to null or default).
     * Updates the quantity of the specified products in a cart.
     */
    replaceCartEntries(requestParameters: ReplaceCartEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CartModificationList>;

    /**
     * Updates the quantity of a single cart entry and the details of the pickup store. Attributes not provided in the request will be defined again (set to null or default)
     * @summary Updates the details of a cart entry.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {number} entryNumber Each entry in a cart has an entry number. Cart entries are numbered in ascending order, starting with zero.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {OrderEntry} orderEntry 
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartEntriesApiInterface
     */
    replaceCartEntryRaw(requestParameters: ReplaceCartEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CartModification>>;

    /**
     * Updates the quantity of a single cart entry and the details of the pickup store. Attributes not provided in the request will be defined again (set to null or default)
     * Updates the details of a cart entry.
     */
    replaceCartEntry(requestParameters: ReplaceCartEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CartModification>;

    /**
     * Updates the quantity of a single cart entry and the details of the pickup store.
     * @summary Updates the details of a cart entry.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {number} entryNumber Each entry in a cart has an entry number. Cart entries are numbered in ascending order, starting with zero.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {OrderEntry} orderEntry 
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartEntriesApiInterface
     */
    updateCartEntryRaw(requestParameters: UpdateCartEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CartModification>>;

    /**
     * Updates the quantity of a single cart entry and the details of the pickup store.
     * Updates the details of a cart entry.
     */
    updateCartEntry(requestParameters: UpdateCartEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CartModification>;

}

/**
 * 
 */
export class CartEntriesApi extends runtime.BaseAPI implements CartEntriesApiInterface {

    /**
     * Retrieves a list of cart entries with the product data.
     * Retrieves the cart entries.
     */
    async getCartEntriesRaw(requestParameters: GetCartEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderEntryList>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getCartEntries.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling getCartEntries.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getCartEntries.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/entries`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderEntryListFromJSON(jsonValue));
    }

    /**
     * Retrieves a list of cart entries with the product data.
     * Retrieves the cart entries.
     */
    async getCartEntries(requestParameters: GetCartEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderEntryList> {
        const response = await this.getCartEntriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves detailed information about a specific entry for the shopping cart.
     * Retrieves the details of a cart entry.
     */
    async getCartEntryRaw(requestParameters: GetCartEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderEntry>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getCartEntry.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling getCartEntry.');
        }

        if (requestParameters.entryNumber === null || requestParameters.entryNumber === undefined) {
            throw new runtime.RequiredError('entryNumber','Required parameter requestParameters.entryNumber was null or undefined when calling getCartEntry.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getCartEntry.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/entries/{entryNumber}`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"entryNumber"}}`, encodeURIComponent(String(requestParameters.entryNumber))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderEntryFromJSON(jsonValue));
    }

    /**
     * Retrieves detailed information about a specific entry for the shopping cart.
     * Retrieves the details of a cart entry.
     */
    async getCartEntry(requestParameters: GetCartEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderEntry> {
        const response = await this.getCartEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a product to the specified cart.
     * Assigns a product to the cart.
     */
    async mediqCreateCartEntryRaw(requestParameters: MediqCreateCartEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CartModification>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling mediqCreateCartEntry.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling mediqCreateCartEntry.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling mediqCreateCartEntry.');
        }

        if (requestParameters.orderEntry === null || requestParameters.orderEntry === undefined) {
            throw new runtime.RequiredError('orderEntry','Required parameter requestParameters.orderEntry was null or undefined when calling mediqCreateCartEntry.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/xml';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/entries`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderEntryToJSON(requestParameters.orderEntry),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CartModificationFromJSON(jsonValue));
    }

    /**
     * Adds a product to the specified cart.
     * Assigns a product to the cart.
     */
    async mediqCreateCartEntry(requestParameters: MediqCreateCartEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CartModification> {
        const response = await this.mediqCreateCartEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a specified entry from the shopping cart to manage the product items.
     * Deletes the cart entry.
     */
    async removeCartEntryRaw(requestParameters: RemoveCartEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling removeCartEntry.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling removeCartEntry.');
        }

        if (requestParameters.entryNumber === null || requestParameters.entryNumber === undefined) {
            throw new runtime.RequiredError('entryNumber','Required parameter requestParameters.entryNumber was null or undefined when calling removeCartEntry.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling removeCartEntry.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/entries/{entryNumber}`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"entryNumber"}}`, encodeURIComponent(String(requestParameters.entryNumber))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a specified entry from the shopping cart to manage the product items.
     * Deletes the cart entry.
     */
    async removeCartEntry(requestParameters: RemoveCartEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeCartEntryRaw(requestParameters, initOverrides);
    }

    /**
     * Adds specific products or overwrites the details of existing products in the cart, based either on the product code or the entry number. For existing products, attributes not provided in the request body will be defined again (set to null or default).
     * Updates the quantity of the specified products in a cart.
     */
    async replaceCartEntriesRaw(requestParameters: ReplaceCartEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CartModificationList>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling replaceCartEntries.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling replaceCartEntries.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling replaceCartEntries.');
        }

        if (requestParameters.orderEntryList === null || requestParameters.orderEntryList === undefined) {
            throw new runtime.RequiredError('orderEntryList','Required parameter requestParameters.orderEntryList was null or undefined when calling replaceCartEntries.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/entries`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrderEntryListToJSON(requestParameters.orderEntryList),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CartModificationListFromJSON(jsonValue));
    }

    /**
     * Adds specific products or overwrites the details of existing products in the cart, based either on the product code or the entry number. For existing products, attributes not provided in the request body will be defined again (set to null or default).
     * Updates the quantity of the specified products in a cart.
     */
    async replaceCartEntries(requestParameters: ReplaceCartEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CartModificationList> {
        const response = await this.replaceCartEntriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the quantity of a single cart entry and the details of the pickup store. Attributes not provided in the request will be defined again (set to null or default)
     * Updates the details of a cart entry.
     */
    async replaceCartEntryRaw(requestParameters: ReplaceCartEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CartModification>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling replaceCartEntry.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling replaceCartEntry.');
        }

        if (requestParameters.entryNumber === null || requestParameters.entryNumber === undefined) {
            throw new runtime.RequiredError('entryNumber','Required parameter requestParameters.entryNumber was null or undefined when calling replaceCartEntry.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling replaceCartEntry.');
        }

        if (requestParameters.orderEntry === null || requestParameters.orderEntry === undefined) {
            throw new runtime.RequiredError('orderEntry','Required parameter requestParameters.orderEntry was null or undefined when calling replaceCartEntry.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/xml';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/entries/{entryNumber}`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"entryNumber"}}`, encodeURIComponent(String(requestParameters.entryNumber))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrderEntryToJSON(requestParameters.orderEntry),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CartModificationFromJSON(jsonValue));
    }

    /**
     * Updates the quantity of a single cart entry and the details of the pickup store. Attributes not provided in the request will be defined again (set to null or default)
     * Updates the details of a cart entry.
     */
    async replaceCartEntry(requestParameters: ReplaceCartEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CartModification> {
        const response = await this.replaceCartEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the quantity of a single cart entry and the details of the pickup store.
     * Updates the details of a cart entry.
     */
    async updateCartEntryRaw(requestParameters: UpdateCartEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CartModification>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling updateCartEntry.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling updateCartEntry.');
        }

        if (requestParameters.entryNumber === null || requestParameters.entryNumber === undefined) {
            throw new runtime.RequiredError('entryNumber','Required parameter requestParameters.entryNumber was null or undefined when calling updateCartEntry.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling updateCartEntry.');
        }

        if (requestParameters.orderEntry === null || requestParameters.orderEntry === undefined) {
            throw new runtime.RequiredError('orderEntry','Required parameter requestParameters.orderEntry was null or undefined when calling updateCartEntry.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/xml';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/entries/{entryNumber}`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"entryNumber"}}`, encodeURIComponent(String(requestParameters.entryNumber))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: OrderEntryToJSON(requestParameters.orderEntry),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CartModificationFromJSON(jsonValue));
    }

    /**
     * Updates the quantity of a single cart entry and the details of the pickup store.
     * Updates the details of a cart entry.
     */
    async updateCartEntry(requestParameters: UpdateCartEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CartModification> {
        const response = await this.updateCartEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
